<div class="form-group row">
    <div class="col-sm-6" *ngFor="let item of SpraApprovalRemarksParams; let i = index;">
        
        <!-- <mat-card *ngIf="this.Level>=1"> -->
        <mat-card class="mt-3">
            <mat-card-title class="font-weight-bold caption-color">Level {{item.LevelID}}
                <span *ngIf="ParentSpraDetails!=undefined && ParentSpraDetails.length > 0 && item.Tag==0">
                    [Original spra:<button type="button"  class="btn btn-link" (click)="onRequestClick();">{{ParentSpraDetails[0].RequestNo}}]</button>
                    SPRA Review Count : {{ParentSpraDetails[0].CurrentRequestNo}}
                </span>
            </mat-card-title>
            <mat-divider></mat-divider>
            <!-- h-100 class remove by rahul yadav on 11/6/2021 -->
            <mat-card-content class="pt-2" *ngIf="item.Tag==1"> 
                <div class="row">
                    <div class="col-sm-4 ">Status</div>
                    <span class="col-sm-1"> : </span>
                    <div class="col-sm-6 font-weight-bold">{{item.AppStatus}} </div>
                </div>
                <div class="row">
                    <div class="col-sm-4" *ngIf="item.IsRequest==1">Requested By</div>
                    <div class="col-sm-4" *ngIf="item.IsRequest==0">Approved By</div>
                    <span class="col-sm-1"> : </span>
                    <div class="col-sm-6 font-weight-bold">{{item.ApprovedBy}} </div>
                </div>
                <div class="row">
                    <div class="col-sm-4" *ngIf="item.IsRequest==1">Requested Date</div>
                    <div class="col-sm-4" *ngIf="item.IsRequest==0">Approved Date</div>
                    <span class="col-sm-1"> : </span>
                    <div class="col-sm-6 font-weight-bold">{{item.ApprovedDate}} </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-4 ">Remarks</div>
                    <span class="col-sm-1"> : </span>
                    <div class="col-sm-6 font-weight-bold">{{item.Remarks}} </div>
                </div>
            </mat-card-content>

            <mat-card-content class="pt-2 pl-2 h-100" *ngIf="item.Tag==0">
                <div class="row" >
                    <div class="col-sm-3 ">Remarks</div>
                    <span class="col-sm-1"> : </span>
                    <div class="col-sm-8">
                        <textarea class="form-control h-50" matInput cdkTextareaAutosize maxlength="2000" 
                        #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
                        [(ngModel)]="item.Remarks"></textarea>
                    </div>
                    <div class="col-sm-4">Action</div>
                    <div class="col-sm-8 pt-2">
                        <mat-radio-group [(ngModel)]="item.AppStatus">
                            <mat-radio-button value="A" class="pr-2" *ngIf="!IsFromApprovedlist">Approved</mat-radio-button>
                            <mat-radio-button value="R" *ngIf="!IsFromApprovedlist" >Reject</mat-radio-button>
                            &nbsp;
                            <mat-radio-button value="V" *ngIf="ShowReviewButton && !IsFromApprovedlist">Review</mat-radio-button>
                          </mat-radio-group>
                          
                    </div>
                </div>
            </mat-card-content>            
        </mat-card>

    </div>


    <div class="col-sm-6" *ngIf="IsSalesAdmin">
    <mat-card class="mt-3">
        <mat-card-title class="font-weight-bold caption-color">Validation Required</mat-card-title>
        <mat-divider></mat-divider>
        <mat-card-content class="pt-2">
            <app-spra-validation-hierarchy (ValidationHierarchyChange)="ValidationHierarchyChange($event)"></app-spra-validation-hierarchy>
        </mat-card-content>
    </mat-card>
</div>

  
</div>